
import Vue from 'vue';
import StepsMixIn from './StepsMixIn.vue';

export default Vue.extend({
  name: 'forgot-page-step-initial',
  mixins: [StepsMixIn],
});
